document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.add-to-cart-btn').forEach(button => {

    const messageEl = button.closest('.hero-buttons').querySelector('.cart-message');

    // Ensure button is clickable
    button.disabled = false;

    button.addEventListener('click', async function () {

      const variantId = this.dataset.productId;

      if (!variantId) {
        showMessage(messageEl, "Please select a product first.");
        return;
      }

      try {
        const cartRes = await fetch('/cart.js', { cache: "no-store" });
        const cart = await cartRes.json();

        const alreadyInCart = cart.items.some(
          item => String(item.id) === String(variantId)
        );

        if (alreadyInCart) {
          showMessage(messageEl, "Product is Already Added to Cart.");
          return;
        }

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!addRes.ok) throw new Error('Add to cart failed');

        window.location.href = '/cart';

      } catch (error) {
        console.error(error);
        showMessage(messageEl, "Something went wrong. Please try again.");
      }

    });

  });

  function showMessage(el, msg) {
    if (!el) return;
    el.textContent = msg;

    setTimeout(() => {
      el.textContent = "";
    }, 5000);
  }

});

// VIDEO LOGIC
document.querySelectorAll('.hero-video-wrapper').forEach(wrapper => {
  const video = wrapper.querySelector('.hero-video');
  const poster = wrapper.querySelector('.video-poster');
  const playBtn = wrapper.querySelector('.play-btn');

  if (!video) return;

  const hasDesktopPoster = wrapper.dataset.desktopPoster === "true";
  const hasMobilePoster = wrapper.dataset.mobilePoster === "true";

  let playHandlerAttached = false;

  function handleVideoBehavior() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const shouldUsePoster = isMobile ? hasMobilePoster : hasDesktopPoster;

    if (!shouldUsePoster) {
      if (poster) poster.classList.add('is-hidden');

      video.classList.remove('is-hidden');

      const tryPlay = () => {
        video.play().catch(() => setTimeout(tryPlay, 500));
      };

      tryPlay();
    }

    else {
      if (!poster) return;

      video.classList.add('is-hidden');
      poster.classList.remove('is-hidden');

      if (!playHandlerAttached && playBtn) {
        playBtn.addEventListener('click', () => {
          poster.classList.add('is-hidden');
          video.classList.remove('is-hidden');
          video.play();
        });

        playHandlerAttached = true;
      }
    }
  }

  // Initial run
  handleVideoBehavior();

  // Handle resize (important edge case)
  window.addEventListener('resize', handleVideoBehavior);
});